import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('components.Transfer.PanelHeader', {
    placeholder: 'Search...',
});
